import { useState } from "react";
import { AddSingleASIN } from "./requests/AddSingleASIN";
import { AddBulkASIN } from "./requests/AddBulkASIN";
import { useDispatch, useSelector } from "react-redux";
import { getAsinList, setAsin } from "../../reducer/asin/Asin.action";
import { GenerateKey } from "../../common/common";
import { useParams } from "react-router-dom";
import { setCollectionsList } from "../../reducer/collection/Collection.action";
import { McaDrawer } from "../mca";

export const ChooseRequests = ({
  show,
  handleClose,
  setShowRequests,
  collectionId,
  requestType = "amazon",
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const _asinBar = useSelector((item) => item.asinReducer.asinBar);

  const [showBulkASIN, setShowBulkASIN] = useState(false);

  const isOfficeworks = requestType === "officeworks";
  const itemLabel = isOfficeworks ? "SKU" : "ASIN";

  const handelOpenAsin = () => {
    dispatch(setAsin(true));
  };

  const handleCloseSin = () => {
    dispatch(setAsin(false));
  };

  const handleOnUpload = () => {
    dispatch(getAsinList({ collection_id: params.id }));
    dispatch(setCollectionsList());
  };

  const handleOnCreated = () => {
    dispatch(setCollectionsList());
  };

  return (
    <>
      <McaDrawer
        open={show}
        onClose={handleClose}
        title="Choose Requests"
        subtitle={`Step 2 of 2 Â· Pick how to add ${itemLabel} records`}
        footer={
          <button
            type="button"
            className="mca-btn mca-btn--outline"
            onClick={handleClose}
          >
            Cancel
          </button>
        }
      >
        <div className="form-stack">
          <button
            type="button"
            className="mca-btn mca-btn--primary"
            onClick={handelOpenAsin}
          >
            Add Single {itemLabel}
          </button>
          <button
            type="button"
            className="mca-btn mca-btn--outline"
            onClick={() => setShowBulkASIN(true)}
          >
            Add Bulk {itemLabel}
          </button>
        </div>
      </McaDrawer>
      <AddSingleASIN
        key={GenerateKey(10)}
        show={_asinBar}
        handleClose={handleCloseSin}
        setShowRequests={setShowRequests}
        collectionId={collectionId}
        onCallback={handleOnCreated}
        requestType={requestType}
      />
      <AddBulkASIN
        show={showBulkASIN}
        callback={handleOnUpload}
        handleClose={() => setShowBulkASIN(false)}
        requestType={requestType}
      />
    </>
  );
};
